import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, isEnabled = true }) {
    const { isAuthenticated, loading } = useAuth();

    // While verifying JWT, don�t redirect yet
    if (loading || isAuthenticated === null) {
        return <div>Loading...</div>; // Optional: spinner or blank page
    }

    // Not logged in
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Route is disabled via portal settings
    if (!isEnabled) {
        return <Navigate to="/home" replace />; // Or redirect to an error page
    }

    return children;
}
